import type { FaireProductEntity } from "../../entity_types/product";

export const p_7cejnmeejd: FaireProductEntity = {
  token: "p_7cejnmeejd",
  type: "product",
  name: "Premium 100g Natural Crystal Tumble Set | Healing Stone Collection for Beginners",
  brandToken: "b_9c6sy2bfcu",
  brandName: "Moon Rituals",
  imageUrl:
    "https://cdn.faire.com/fastly/9a343a9b52597d389c5e89b6ada639b53bf3c6994d52fa1174a24c0538e6a0a5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/240639f94af39206627ba61eb824f90f0cc355891c40d8b2b8a4c516a2a819a0.jpeg",
    "https://cdn.faire.com/fastly/9eb5b5dc62350c9520aa34c929419240808fd7807cf66af9276eedf9cfdd13dd.jpeg",
    "https://cdn.faire.com/fastly/1b4827901d08ce23428ece6a6cf5abf7af604eb995eb445b6bf8b41a959497de.jpeg",
    "https://cdn.faire.com/fastly/99353442f21e92734a6ed326f8fe251046b207c2d733cae5d4e0e1d692eb635f.jpeg",
    "https://cdn.faire.com/fastly/142f392dcada1ebe889d20af8c769157666a85e28aadbaff416420ee61f3820c.jpeg",
    "https://cdn.faire.com/fastly/4e29d7d647c87e5f11107ea1bf76a350082941681b81331ebffe1aa417acdf1c.jpeg",
    "https://cdn.faire.com/fastly/53b5859223e2277810be3d9eb840a7004e767236400fb90d67bdce4887dac2db.jpeg",
    "https://cdn.faire.com/fastly/f7e6fd7d6a25fc0320654ab339aa0bb5ea925754632c0db0cbf7d8eaef8ee877.jpeg",
    "https://cdn.faire.com/fastly/91b988e8f22dcadc66bcbe0b7c9ce78b5ee5ffb03c0208544d0675a9de76af70.jpeg",
    "https://cdn.faire.com/fastly/fc6c44f040e079d0d7e9091b0cbad3dea3ec25a1e506b814f6775a2a5524d531.jpeg",
    "https://cdn.faire.com/fastly/64f5fc8695c9de735fd1d204a1cffd63f9fed64f599004892f7d6bea892a703c.jpeg",
    "https://cdn.faire.com/fastly/5e08b2b37b79a530923732793769c471670b36101b8062af187b96d989e95c0f.jpeg",
    "https://cdn.faire.com/fastly/dd70a916d0a80971352974689d9b8f0bb886677324a5fe1229bae9426fffcfe0.jpeg",
    "https://cdn.faire.com/fastly/b84958308f64d6bc27e1e9275f21d2f4e56baa94b7de9d84fdc59b63dd35c47d.jpeg",
    "https://cdn.faire.com/fastly/74949b448751a3b979e3a7d3334d154187c61fee4d0a7e8d90c4c60cd3acd971.jpeg",
    "https://cdn.faire.com/fastly/f1bbc96b45a6e6017138320ed6d89fcc367e76d6260f25fa772db8fc3598e439.jpeg",
    "https://cdn.faire.com/fastly/870bc807ec4c189990e83d11142e85809ec0bec66d412781554c5714b2f65b4f.jpeg",
    "https://cdn.faire.com/fastly/cddf22e8576af1db9a726f3b33b5eb78687dd944ca5f50991746c92b6b921586.jpeg",
  ],
  priceDollars: 5,
  description:
    "Description: Discover the magic of our Variety Crystal Tumble Set, a delightful collection of small tumbles (2-3cm, 100g, 5-10 tumbles in one pack) featuring an array of crystals. Hand-selected for their unique energies and vibrant colors, this set includes Clear Quartz, Rose Quartz, Yellow Agate, Red Agate, Flower Agate, Carnelian, Black Obsidian, Moss Agate, Green Aventurine, Tiger Eye, Labradorite, Green Strawberry Quartz, Citrine, Lapis Lazuli, and Dream Amethyst.\n\n\n\nCrystal Highlights:\n\n * Clear Quartz: Amplify energy and clarity. \n * Rose Quartz: Embrace love and compassion. \n * Yellow Agate: Bring warmth and positivity. \n * Red Agate: Enhance vitality and grounding.",
  tags: [],
  msrpDollars: 10,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:47.945Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
